// extracted by mini-css-extract-plugin
export default {"button":"cqqBjArpivHAyI7tUQFF","icon":"oWjBCFpFCYgLOT9DCoK0"};